import { useState, useCallback } from 'react';

const STORAGE_KEY = 'joystance_notif_prefs';

export interface NotifPrefs {
  all: boolean;       // master switch
  messages: boolean;  // DMs
  events: boolean;    // event announcements & happenings-now
  nearbyPins: boolean;// new pins in area
}

const DEFAULTS: NotifPrefs = {
  all: true,
  messages: true,
  events: true,
  nearbyPins: true,
};

function load(): NotifPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
  } catch { return DEFAULTS; }
}

function save(p: NotifPrefs) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); } catch {}
}

export function useNotifPrefs() {
  const [prefs, setPrefs] = useState<NotifPrefs>(load);

  const update = useCallback((partial: Partial<NotifPrefs>) => {
    setPrefs(prev => {
      const next = { ...prev, ...partial };
      // Turning the master off cascades — turning it on restores previous individual settings
      save(next);
      return next;
    });
  }, []);

  // Derived: true only when both master and the individual switch are on
  const isEnabled = useCallback((type: keyof Omit<NotifPrefs, 'all'>): boolean => {
    return prefs.all && prefs[type];
  }, [prefs]);

  return { prefs, update, isEnabled };
}
